export class BaseUnitHistory {
  companyPartNumber: string;
  manufacturerPartNumber: string;
  manufacturerSerialNumber: string;
  noun: string;
  description: string;
  fleetCode: string;
  acn: string;
  position: string;
  installDate: Date;
  removalDate: Date | string;
  timeSinceInstall: number;
  csi: number;
  dsi: number;
  repairTypeDescription?: any;
  faultCode?: any;
  removalReasonCode: string;
  originalAtaChr: string;
  dscrpNbr: string;
  cut_1: string;
  finalFix: string;
  discrepancyText?: any;
  extendedCorrectiveAction?: any;
  removalComments: string;
  repairComments?: any;
  derivedRepairOrdNbr?: any;
  fscCode?: any;
  vendorName?: any;
  repeatAcftInd: number;
  engineManufacturer: string;
  partTsoAtRemoval: number;
  partCsoAtRemoval: number;
  partDsoAtRemoval?: any;
  netPrice?: any;
  totalSoActualRepairCost?: any;
  paidSoInd: number;
  claimNbr?: any;
  rejectedWntyInd: number;
  approvedWntyInd: number;
  allWntyClaimInd: number;
  serviceOrderInd: number;
  derivedRepairInd: number;
  derivedOrderCost: number;
  relM2CappedDlyCost: number;
  relDivCost: number;
  relRtoCost: number;
  relIfsdCost: number;
  relDelayTypeCd?: any;
  relDlyCxlInd?: any;
  relM2DlyMinutes: number;
  relIfsdInd: number;
  relDivInd: number;
  relSwappedAcInd: number;
  relAtbInd: number;
  relBtbInd: number;
  relRtoInd: number;
  relOtherInd: number;
  relSmokeInd: number;
  relDamageInd: number;
  relEmergencyInd: number;
  // relTfoaInd: number;
  dscrpTypeDesc?: any;
  melControlNbr?: any;
  cumAvgTsiByCsnAtInst?: any;
  cumAvgTsiByCpnAtInst: number;
  cumAvgTsiByMpnAtInst: number;
  cumAvgTsiByCsnAtRemv: number;
  cumAvgTsiByCpnAtRemv: number;
  cumAvgTsiByMpnAtRemv: number;
  installStation: string;
  installDept: string;
  removalStation: string;
  removalDept: string;
  acnTsnAtInstall: number;
  acnCsnAtInstall: number;
  partTsnAtInstall: number;
  partCsnAtInstall: number;
  partDsnAtInstall?: any;
  partTsoAtInstall: number;
  partCsoAtInstall: number;
  partDsoAtInstall?: any;
  acnTsnAtRemoval: number;
  acnCsnAtRemoval: number;
  partTsnAtRemoval: number;
  partCsnAtRemoval: number;
  partDsnAtRemoval?: any;
  repairStation?: any;
  repairDept?: any;
  repairDt?: any;
  repairTypeCd: string;
  soNbr?: any;
  installWoNbr?: any;
  removalWoNbr?: any;
  parentCpn: string;
  parentCsn: string;
  removalReasonDesc: string;
  removalMechId: string;
  removalCashFlag: string;
  removalCashInd: number;
  unschedRemovalFlag: string;
  partInstallHistoryIsn: number;
  masterPartIsn: number;
  relM2Ind: number;
  relM2CxlInd: number;
  relM2DlyInd: number;
  relCxlInd: number;
  relDlyInd: number;
  relValidM2Ind: number;
  relCappedDlyCost: number;
  relCappedDlyMinutes: number;
  relTotalDlyMinutes: number;
  relM4Ind: number;
  sigEventInd: number;
  sigEventSum: number;
  painValue: number;
  tsrAtInstall: number;
  tsrAtRemoval: number;
  tsvvAtInstall: number;
  tsvvAtRemoval: number;
  tsurAtInstall: number;
  tsurAtRemoval: number;
  csrAtInstall: number;
  csrAtRemoval: number;
  csvvAtInstall: number;
  csvvAtRemoval: number;
  csurAtInstall: number;
  csurAtRemoval: number;
  lastDerivedRepairOrdNbr?: any;
  lastFsc?: any;
  lastVend?: any;
  lastNetPrice?: any;
  lastActualCost?: any;
  lastRepairTypeCd?: any;
  lastFaultCd?: any;
  prevRemvDerivedRepairOrdNbr?: any;
  prevRemvFsc?: any;
  prevRemvVend?: any;
  prevRemvSoPrice?: any;
  prevRemvActualCost?: any;
  prevRemvRepairTypeCd?: any;
  prevRemvFaultCd?: any;
  prevRmvlNffInd?: any;
  preRemvReasonCd?: any;
  prevRepairDate?: any;
  prevRmvlCashFlag?: any;
  prevRmvlCashInd?: any;
  prevRemovalDate?: any;
  prevFleetCode?: any;
  csn: string;
  latestFlag: string;
  fleet: string;
  series: string;
  installCount: number;
  repairCount: number;
  overhaulCount: number;
  otherCount: number;
  totalRemovals: number;
  crtValidInstall: number;
  crtValidRemoval: number;
  unscheduledRmvl: number;
  nonZeroUnscheduledRmvl: number;
  bfsRmvl: number;
  bfsValidRmvl: number;
  unschedOrBfsRmvl: number;
  nffRmvl: number;
  faultRmvl: number;
  nffValidRmvl: number;
  shopVisitNffRmvl: number;
  shopVisitNffValidRmvl: number;
  lowTsi_20Avg: number;
  firstZeroRecord: number;
  acquisitionErrantTimeInd: number;
  averageExclusionInd: number;
  extremeInfantMortality_25Cyc: number;
  extremeInfantMortality_25CycNff: number;
  extremeInfantMortality_25CycPrevNff: number;
  consecutiveEimPreviousNffCount: number;
  meetsRogueTsi: number;
  rogueValid: number;
  rmoInd: number;
  repairInd: number;
  ohInd: number;
  benchTestInd: number;
  shotgunCountTotal: number;
  shotgunCountFaults: number;
  simulatorInstallInd: number;
  dscrpCpnRmvlCount: number;
  cpnAcnRmvlCount: number;
  cpnAcnUnschedRmvlCount: number;
  painDelayCost: number;
  painAtbCost: number;
  painDivCost: number;
  painRtoCost: number;
  painIfsdCost: number;
  painEmerCost: number;
  painOosEventCost: number;
  painPdisCost: number;
  painWdlCost: number;
  painRdlCost: number;
  painUnschedCost: number;
  painBfsCost: number;
  painOtherRmvlCost: number;
  painLowTsiCost: number;
  painNffCost: number;
  smkCnt: number;
  damageCnt: number;
  emerCnt: number;
  // tfoaCnt: number;
  wdlPackageCnt: number;
  rdlPackageCnt: number;
  removalMonth: number;
  removalYear: number;
  removalMmmyyyy?: any;
  dscrpType?: any;
  dscrpStatus?: any;
  openSta?: any;
  factSta?: any;
  openDtm?: any;
  factDtm?: any;
  mod?: any;
  modPos?: any;
  factAction?: any;
  fsuActions?: any;
  originalAtaChapter?: any;
  recodedCorrectiveActionAta?: any;
  recodedCorrectiveActionAtaChapter?: any;
  recodedCorrectiveActionAtaDescription?: any;
  reportingCorrectiveActionAta?: any;
  reportingCorrectiveActionAtaChapter?: any;
  reportingCorrectiveActionAtaDescription?: any;
  reportingCorrectiveActionAtaSource?: any;
  recodedMlfnCd?: any;
  recodedMlfnCdDescription?: any;
  recodedFixCd?: any;
  recodedFixCdDescription?: any;
  majorMinorRepairInd?: any;
  catRelatedStatusInd?: any;
  plannedItemInd?: any;
  workOrder?: any;
  openItemFlag?: any;
  melCatStatus?: any;
  melOpenDtm?: any;
  melCloseDtm?: any;
  melDropDeadDtm?: any;
  melNbr?: any;
  melCategory?: any;
  oosEventHrs?: any;
  oosEventCnt?: any;
  installDtN: number;
  removalDtN: number;
  insTimeKey: Date;
  remTimeKey: Date;
  fleetModelCd: string;
  prevCsnIsn_1?: any;
  prevPosIsn_1?: any;
  excludedCpn: number;
  originalRemovalReasonCode?: any;
  subassemblyOverrideInd: number;
  miscodedScheduledRemovalInd: number;
  miscodedBfsInd: number;
  proratedApuInd: number;
  apuFlag?: any;
  ahmInd: number;
  removalDateStringYYYYMM?: string;
  removalDateStringYYYYMMDD?: string;
  removalDateStringMMMYYYY?: string;
  installDateStringYYYYMM?: string;
  installDateStringYYYYMMDD?: string;
  installDateStringMMMYYYY?: string;
  repairDateStringYYYYMM?: string;
  repairDateStringYYYYMMDD?: string;
  repairDateStringMMMYYYY?: string;
  optixSoObjectId: string;
  tsiBucket100: number;
  tsiBucket1000: number;
  csiBucket100: number;
  csiBucket1000: number;
  arlIndicator: number;
  arlAircraft: string;
  arlAcquisitionDate: Date;
  arlDaysSinceAcquisition: number;
  arlFleet: string;
  arlPsaaNffEligible: number;
  historyPsaaNffEligible: number;
  psaa180DayDate: Date;
  psaa180DayCountdown: number;
  trueTsiUnknown: number;
  wiseProblemDesc: string;
  wiseAtaChapter: number;
  wiseSubAta: number;
  wisePidOid: number;
  fleetCodeNullFilter: string;
  acnNullFilter: string;
  workOrderRepairCost: number;
  workOrderLaborCost: string;
  workOrderMaterialCost: string;
  tagNumber: string;
  tagNumberCount: number;
  tagNumberConcatenate: string;
  tagHistoryIsn: number;
  tagCreateDate: Date;
  tagCreatedBy: string;
  tagStatus: string;
  tagStatusDate: Date;
  isnPrepCounter: number;
  baseUnitHistoryIsn: number;
  newRecordIndicator: number;
  aiFlightPhase: string;
  aiFlightPhaseExplanation: string;
  discrepancySummary: string;
  crtCsnIsn: number;
  crtCsnMsnIsn: number;
  cstMsnIsn: number;
  latestCsnIndicator: number;
  latestCsnMsnIndicator: number;
  latestMsnIndicator: number;
  latestFlagOriginal: string;
  masterPartIsnPreviousOne: number;
  masterPartIsnPreviousTwo: number;
  masterPartPreviousUnscheduledIsnOne: number;
  masterPartPreviousUnscheduledIsnTwo: number;
  previousUnscheduledTsiAverage: number;
  previousUnscheduledM2Count: number;
  previousUnscheduledSigEventIndicatorCount: number;
  previousUnscheduledSigEventCount: number;
  previousUnscheduledSoCostSum: number;
  previousUnscheduledSoCostAverage: number;
  previousUnscheduledM2CostSum: number;
  previousUnscheduledM2CostAverage: number;
  previousUnscheduledAtbCostSum: number;
  previousUnscheduledAtbCostAverage: number;
  previousUnscheduledDivCostSum: number;
  previousUnscheduledDivCostAverage: number;
  previousUnscheduledRtoCostSum: number;
  previousUnscheduledRtoCostAverage: number;
  previousUnscheduledIfsdCostSum: number;
  previousUnscheduledIfsdCostAverage: number;
  previousUnscheduledPainSum: number;
  previousUnscheduledPainAverage: number;
  soRaiIndicator: number;
}
